import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import SimpleModal from "./components/modals/SimpleModal";
import MyProfileModal from "./components/modals/MyProfileModal";
import ChangePasswordModal from "./components/modals/ChangePasswordModal";
import RechargeModal from "./components/modals/RechargeModal";
import {SelectServerPage} from "./components/embedpages/select-server-page";
import {UpdateLauncherPage} from "./components/embedpages/update-launcher-page";

const NewDashboard = () => {
    const navigate = useNavigate();

    const {user, logout} = useAuth();

    // Se o modal de perfil está aberto
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
    const [isRechargeModalOpen, setIsRechargeModalOpen] = useState(false);

    const isOutdated = (localStorage.getItem("web_version") != null && process.env.REACT_APP_VERSION != null) && (localStorage.getItem("web_version") !== process.env.REACT_APP_VERSION);

    const handleLogout = () => {
        logout();
        navigate('/');
    }

    if (user == null) {
        return (<>Carregando...</>);
    }

    return (<div className={"flex items-center justify-center p-4 dashboard-page"}>

            <div className="dashboard-container bg-white w-full max-w-6xl">
                <div className="bg-gray-800 text-white px-6 py-4 flex items-center md:justify-between">
                    <div className="hidden md:flex items-center">
                        <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mr-4">
                            <i className="fas fa-gamepad text-white text-xl"></i>
                        </div>
                        <h1 className="text-2xl font-bold">DDtank <span className="text-blue-300">Splush</span></h1>
                    </div>

                    <div className="flex flex-col justify-center w-full md:w-auto md:flex-row items-center space-x-4">
                        <div className="flex items-center space-x-2">
                            {/*<div*/}
                            {/*    className="user-avatar rounded-full flex items-center justify-center text-white text-2xl font-bold">*/}
                            {/*    JP*/}
                            {/*</div>*/}
                            <img alt={"Foto de perfil"}
                                 src={`https://ui-avatars.com/api/?name=${user.name}&color=FFFFFF&background=3b82f6`}
                                 className={"user-avatar rounded-full flex items-center justify-center text-white text-2xl font-bold"}></img>
                            <div>
                                <div className="font-medium">{user.name}</div>
                                <div className="text-xs text-gray-300">Jogador | <span className="text-yellow-300"><i
                                    className="fas fa-coins"></i> 0</span></div>
                            </div>
                        </div>
                        <div className="flex space-x-2 mt-2 md:mt-0">
                            <button onClick={() => setIsRechargeModalOpen(true)}
                                    className="btn-coupons text-white px-4 py-1 rounded-lg text-sm flex items-center coupon-animation">
                                <i className="fas fa-plus-circle mr-1"></i> Cupons
                            </button>

                            <div className="dropdown">
                                <button
                                    className="account-btn text-white px-4 py-1 rounded-lg text-sm flex items-center">
                                    <i className="fas fa-user-circle mr-1"></i> Minha conta <i
                                    className="fas fa-chevron-down ml-1 text-xs"></i>
                                </button>
                                <div className="dropdown-content">
                                    <a href="#" className="flex items-center"
                                       onClick={() => setIsProfileModalOpen(true)}>
                                        <i className="fas fa-user mr-2"></i> Meu perfil
                                    </a>
                                    <a href="#" className="flex items-center"
                                       onClick={() => setIsChangePasswordModalOpen(true)}>
                                        <i className="fas fa-key mr-2"></i> Trocar senha
                                    </a>
                                    {/*<a href="#" className="flex items-center" onClick={() => setIsRechargeModalOpen(true)}>*/}
                                    {/*    <i className="fas fa-coins mr-2"></i> Recarregar*/}
                                    {/*</a>*/}
                                    {/*<a href="#" className="flex items-center" onClick="showModal('history')">*/}
                                    {/*    <i className="fas fa-history mr-2"></i> Histórico*/}
                                    {/*</a>*/}
                                    <a href="#" className="flex items-center text-red-500"
                                       onClick={() => handleLogout()}>
                                        <i className="fas fa-sign-out-alt mr-2"></i> Sair
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    !isOutdated ? <SelectServerPage></SelectServerPage> : <UpdateLauncherPage></UpdateLauncherPage>
                }

                <SimpleModal title={"Meu perfil"} content={<MyProfileModal/>} isModalOpen={isProfileModalOpen}
                             setIsModalOpen={setIsProfileModalOpen}></SimpleModal>
                <SimpleModal title={"Trocar senha"} content={<ChangePasswordModal/>}
                             isModalOpen={isChangePasswordModalOpen}
                             setIsModalOpen={setIsChangePasswordModalOpen}></SimpleModal>
                <SimpleModal title={"Recarga"} content={<RechargeModal setIsOpen={setIsRechargeModalOpen}/>}
                             isModalOpen={isRechargeModalOpen} setIsModalOpen={setIsRechargeModalOpen}></SimpleModal>

                <div className="bg-gray-800 text-white px-6 py-4 text-center text-sm">
                    <p>DDtank Splush v{localStorage.getItem("web_version")} © 2025 Todos os direitos reservados</p>
                    <div className="flex justify-center space-x-4 mt-2">
                        <a href="#" className="hover:text-blue-300"><i className="fab fa-facebook"></i></a>
                        <a href="#" className="hover:text-blue-400"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="hover:text-red-400"><i className="fab fa-youtube"></i></a>
                        <a href="#" className="hover:text-purple-400"><i className="fab fa-discord"></i></a>
                    </div>
                </div>
            </div>
        </div>);
}

export default NewDashboard;